
class AthleteRankSearch{
    defaultOptions() {
        return {
            '$container': null,
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onFilterChange = this.onFilterChange.bind(this);

        this.$container = this.settings.$container;
        if(!this.$container){
            window.notify("$container is missing in component/row/AthleteRankSearch","error");
        }

        this.$form = $('form',this.$container);

        this.$filterSaison = $('select[name="saison"]',this.$form);
        this.$filterDiscipline = $('select[name="discipline"]',this.$form);
        this.$filterGenre = $('select[name="genre"]',this.$form);
        this.$filterCategorie = $('select[name="categorie"]',this.$form);
        this.$filterCollectif = $('select[name="shn"]',this.$form);
        this.$filterOnlyFrench = $('select[name="onlyFrench"]',this.$form);

        this.currentOffset = 0;
        this.currentRequest =  null;

        this.initialize();
    }


    initialize(){
        var self = this;

        this.$filterSaison.on('change',this.onFilterChange);
        this.$filterDiscipline.on('change',this.onFilterChange);
        this.$filterGenre.on('change',this.onFilterChange);
        this.$filterCategorie.on('change',this.onFilterChange);
        this.$filterCollectif.on('change',this.onFilterChange);
        this.$filterOnlyFrench.on('change',this.onFilterChange);

    }

    onFilterChange(event){
        let $filter = $(event.target);

        this.$form.trigger('submit');
    }
}

module.exports = AthleteRankSearch;
